import React, { Component } from "react";
import Window from "../../2/Controls/Window";
import { exportFile } from "../../../actions/DataExporter"; 
import ExportButton from "../../2/Controls/ExportButton";
import { getProperty } from "../../../CommonFunctions";

const statusFilters = ["all", "pending", "sent", "delivered", "read", "failed"];

const tabs = [
  { key: "whatsapp", label: "WhatsApp", setting: "EnableWhatsapp" },
  { key: "sms", label: "SMS", setting: "EnableSMS" },
  { key: "email", label: "Email", setting: "EnableEmail" },
];



// 🎨 Helper function for status badge styling
const getStatusStyles = (status) => {
  switch (status) {
    case "delivered":
      return {
        backgroundColor: "#f0fdf4",
        color: "#166534",
        borderColor: "#86efac",
      };
    case "read":
      return {
        backgroundColor: "#eef2ff",
        color: "#4338ca",
        borderColor: "#c7d2fe",
      };
    case "sent":
      return {
        backgroundColor: "#eff6ff",
        color: "#1e40af",
        borderColor: "#bfdbfe",
      };
    case "pending":
      return {
        backgroundColor: "#fefce8",
        color: "#854d0e",
        borderColor: "#fde047",
      };
    case "failed":
      return {
        backgroundColor: "#fef2f2",
        color: "#991b1b",
        borderColor: "#fca5a5",
      };
    default:
      return {
        backgroundColor: "#f3f4f6",
        color: "#374151",
        borderColor: "#d1d5db",
      };
  }
};

class RunHistoryDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "whatsapp",
      historyData: [],
      loading: false,
      currentFilter: "all",
      exportLoading: false,
    };
  }

  componentDidMount() {
    const { campaign } = this.props;
    const availableTabs = this.getAvailableTabs();
    if (availableTabs.length > 0) {
      this.setState({ activeTab: availableTabs[0].key });
    }

    if(availableTabs[0].key==="whatsapp"){
this.fetchData();
    }

    
  }

  componentDidUpdate(prevProps, prevState) {
    const { campaign, currentRunHistoryDate } = this.props;
    const { activeTab } = this.state;

    const campaignIdChanged = getProperty(prevProps.campaign, '_id') !== getProperty(campaign, '_id');
    const dateChanged = prevProps.currentRunHistoryDate !== currentRunHistoryDate;
    const tabChanged = prevState.activeTab !== activeTab;

    if ((campaignIdChanged || dateChanged || tabChanged) && 
        getProperty(campaign, '_id') && 
        currentRunHistoryDate && 
        activeTab === 'whatsapp') {
      this.fetchData();
    } else if (activeTab !== 'whatsapp') {
      this.setState({ historyData: [] });
    }
  }

  getAvailableTabs = () => {
    const { campaign } = this.props;
    const availableTabs = [];
    
    if (getProperty(campaign, 'EnableWhatsapp')) {
      availableTabs.push({ key: "whatsapp", label: "WhatsApp" });
    }
    if (getProperty(campaign, 'EnableSMS')) {
      availableTabs.push({ key: "sms", label: "SMS" });
    }
    if (getProperty(campaign, 'EnableEmail')) {
      availableTabs.push({ key: "email", label: "Email" });
    }
    
    return availableTabs;
  };

  fetchData = async () => {
    const { campaign, currentRunHistoryDate } = this.props;
    
    try {
      this.setState({ loading: true });
      const data = await this.props.getHistoryData(getProperty(campaign, '_id'), currentRunHistoryDate);
      if (getProperty(data, 'code') === "0") {
        this.setState({ historyData: getProperty(data, 'data') || [] });
      } else {
        this.setState({ historyData: [] });
      }
    } catch (error) {
      console.error("Error fetching history:", error);
      this.setState({ historyData: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  // Filter by selected status
  getFilteredData = () => {
    const { historyData, currentFilter } = this.state;
    return currentFilter === "all"
      ? historyData
      : historyData.filter((item) => getProperty(item, 'status') === currentFilter);
  };

  // Export Handler using dataExporter utility
  handleExport = async (type) => {
    const filteredData = this.getFilteredData();
    
    // 🛑 Handle Alert for no data
    if (!filteredData.length) {
      alert("⚠️ Cannot export. No data available based on current filters.");
      return;
    }

    this.setState({ exportLoading: true });

    try {
      // Define column configuration for export
      const columns = [
        { header: "S.No.", field: "sno", type: "number" },
        { header: "Name", field: "name" },
        { header: "Mobile", field: "mobile" },
        { header: "Status", field: "status" },
        { header: "Sent At", field: "sentAt", type: "date" },
      ];

      // Prepare data for export
      const exportData = filteredData.map((item, index) => {
        const metaData = getProperty(item, 'metaData');
        const customer = metaData ? getProperty(metaData, 'customer') : undefined;
        
        return {
          sno: index + 1,
          name: (customer && getProperty(customer, 'name')) || "N/A",
          mobile: (customer && getProperty(customer, 'mobile')) || "N/A",
          status: (getProperty(item, 'status') ? getProperty(item, 'status').toUpperCase() : "N/A"),
          sentAt: getProperty(item, 'createdAt'),
        };
      });
      
      const { currentFilter } = this.state;
      const title = `campaign-history_${currentFilter}_${new Date().toISOString().slice(0, 10)}`;

      // Use the exportFile utility
      exportFile({
        data: exportData,
        columns: columns,
        fileType: "EXCEL", // "CSV" or "EXCEL"
        title: title,
        landscape: false,
        allowEmpty: false,
      });
      
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("An error occurred during export. Please try again.");
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  // Calculate counts for dynamic filter buttons
  getStatusCount = (status) => {
    const { historyData } = this.state;
    if (status === 'all') return historyData.length;
    return historyData.filter(item => getProperty(item, 'status') === status).length;
  };

  handleClose = () => {
    const { setShowRunHistoryDetails } = this.props;
    if (setShowRunHistoryDetails) {
      setShowRunHistoryDetails(false);
    }
  };

  // Styles
  styles = {
    container: {
      backgroundColor: "#f9fafb",
      minHeight: "100%",
      padding: "20px",
    },
    tabHeader: {
      display: "flex",
      gap: "12px",
      marginBottom: "24px",
      borderBottom: "1px solid #e5e7eb",
      paddingBottom: "12px",
    },
    tabButton: (isActive) => ({
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "600",
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      border: "none",
      cursor: "pointer",
      ...(isActive
        ? {
            backgroundColor: "#2563eb",
            color: "#ffffff",
            boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
          }
        : {
            backgroundColor: "#ffffff",
            color: "#374151",
            border: "1px solid #d1d5db",
          }),
    }),
    noDataContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "192px",
      backgroundColor: "#ffffff",
      border: "1px dashed #d1d5db",
      borderRadius: "12px",
      boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
    },
    noDataText: {
      fontSize: "18px",
      color: "#6b7280",
      fontWeight: "500",
    },
    filterExportContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
      flexWrap: "wrap",
      gap: "16px",
      padding: "16px",
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      border: "1px solid #f3f4f6",
    },
    filterGroup: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
    },
    filterButton: (isActive) => ({
      padding: "6px 12px",
      border: "1px solid",
      borderRadius: "9999px",
      fontSize: "12px",
      fontWeight: "500",
      transition: "all 0.2s ease-in-out",
      cursor: "pointer",
      textTransform: "capitalize",
      ...(isActive
        ? {
            backgroundColor: "#9333ea",
            color: "#ffffff",
            borderColor: "#9333ea",
          }
        : {
            backgroundColor: "#f9fafb",
            color: "#4b5563",
            borderColor: "#d1d5db",
          }),
    }),
    tableContainer: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      border: "1px solid #f3f4f6",
      overflow: "hidden",
    },
    tableWrapper: {
      overflow: "auto",
      maxHeight: "70vh",
    },
    table: {
      minWidth: "100%",
      fontSize: "14px",
      borderCollapse: "collapse",
    },
    tableHeader: {
      backgroundColor: "#f9fafb",
      position: "sticky",
      top: 0,
      zIndex: 10,
    },
    th: {
      padding: "16px",
      textAlign: "left",
      fontWeight: "bold",
      color: "#374151",
    },
    thSNo: {
      padding: "16px",
      textAlign: "left",
      fontWeight: "bold",
      color: "#374151",
      width: "64px",
    },
    thSentAt: {
      padding: "16px",
      textAlign: "left",
      fontWeight: "bold",
      color: "#374151",
      width: "160px",
    },
    td: {
      padding: "16px",
    },
    tdSNo: {
      padding: "16px",
      color: "#6b7280",
    },
    tdName: {
      padding: "16px",
      fontWeight: "500",
      color: "#1f2937",
    },
    tdMobile: {
      padding: "16px",
      color: "#4b5563",
    },
    tdStatus: {
      padding: "16px",
    },
    statusBadge: (status) => ({
      display: "inline-block",
      padding: "4px 12px",
      fontSize: "12px",
      fontWeight: "600",
      borderRadius: "9999px",
      border: "1px solid",
      textTransform: "capitalize",
      ...getStatusStyles(status),
    }),
    tdSentAt: {
      padding: "16px",
      color: "#6b7280",
      fontSize: "12px",
    },
    loadingText: {
      textAlign: "center",
      padding: "48px 0",
      fontSize: "18px",
      fontWeight: "500",
      color: "#3b82f6",
    },
    noRecordsText: {
      textAlign: "center",
      padding: "48px 0",
      fontSize: "18px",
      fontWeight: "500",
      color: "#6b7280",
    },
    tableRow: {
      borderBottom: "1px solid #f3f4f6",
      transition: "background-color 0.1s ease-in-out",
    },
  };

  render() {
    const { campaign, currentRunHistoryDate } = this.props;
    const { activeTab, loading, currentFilter, exportLoading } = this.state;
    
    const availableTabs = this.getAvailableTabs();
    const filteredData = this.getFilteredData();
    
    const activeCampaignSetting = tabs.find((t) => t.key === activeTab);
    const settingKey = activeCampaignSetting ? getProperty(activeCampaignSetting, 'setting') : undefined;
    const isFeatureEnabled = settingKey ? getProperty(campaign, settingKey) : false;

    return (
      <Window
        header={getProperty(campaign, 'Name') || "Campaign History"}
        onClose={this.handleClose}
        size="large"
       modal
      >
        <div style={this.styles.container}>
          {/* 🚀 TAB HEADER */}
          <div style={this.styles.tabHeader}>
            {availableTabs.map((tab) => (
              <button
                key={getProperty(tab, 'key')}
                onClick={() => this.setState({ activeTab: getProperty(tab, 'key') })}
                style={this.styles.tabButton(activeTab === getProperty(tab, 'key'))}
              >
                {getProperty(tab, 'label')}
              </button>
            ))}
          </div>

          {/* ❌ NO DATA / FEATURE DISABLED BLOCK */}
          {!isFeatureEnabled || activeTab !== "whatsapp" ? (
            <div style={this.styles.noDataContainer}>
              <p style={this.styles.noDataText}>
                {activeTab.toUpperCase()} feature is either disabled or no history data is available.
              </p>
            </div>
          ) : (
            <>
              {/* 📋 FILTERS + EXPORT HEADER */}
              <div style={this.styles.filterExportContainer}>
                <div style={this.styles.filterGroup}>
                  {statusFilters.map((st) => (
                    <button
                      key={st}
                      onClick={() => this.setState({ currentFilter: st })}
                      style={this.styles.filterButton(currentFilter === st)}
                    >
                      {st} ({this.getStatusCount(st)})
                    </button>
                  ))}
                </div>

                {/* Export Button */}
                <div>
                  <ExportButton onExport={this.handleExport} loading={exportLoading} />
                </div>
              </div>

              {/* 📊 TABLE VIEW */}
              <div style={this.styles.tableContainer}>
                <div style={this.styles.tableWrapper}>
                  {loading ? (
                    <p style={this.styles.loadingText}>Loading history data...</p>
                  ) : filteredData.length === 0 ? (
                    <p style={this.styles.noRecordsText}>
                      No records found for the current filter: **{currentFilter.toUpperCase()}**
                    </p>
                  ) : (
                    <table style={this.styles.table}>
                      <thead style={this.styles.tableHeader}>
                        <tr>
                          <th style={this.styles.thSNo}>S.No.</th>
                          <th style={this.styles.th}>Customer Name</th>
                          <th style={this.styles.th}>Mobile</th>
                          <th style={this.styles.th}>Status</th>
                          <th style={this.styles.thSentAt}>Sent At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => {
                          const metaData = getProperty(item, 'metaData');
                          const customer = metaData ? getProperty(metaData, 'customer') : undefined;
                          
                          return (
                            <tr 
                              key={getProperty(item, '_id')} 
                              style={this.styles.tableRow}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#f9fafb";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                              }}
                            >
                              <td style={this.styles.tdSNo}>{index + 1}</td>
                              <td style={this.styles.tdName}>
                                {(customer && getProperty(customer, 'name')) || 'N/A'}
                              </td>
                              <td style={this.styles.tdMobile}>
                                {(customer && getProperty(customer, 'mobile')) || 'N/A'}
                              </td>
                              <td style={this.styles.tdStatus}>
                                <span style={this.styles.statusBadge(getProperty(item, 'status'))}>
                                  {getProperty(item, 'status')}
                                </span>
                              </td>
                              <td style={this.styles.tdSentAt}>
                                {new Date(getProperty(item, 'createdAt')).toLocaleString()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </Window>
    );
  }
}

export default RunHistoryDetails;